import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IToasterInput, IToasterVariant } from '../models/interfaces';
import { InternalMsgService } from './internal.msg.service';

@Injectable({
    providedIn: 'root'
})
export class StatusMessagesService {

    constructor( private msgService: InternalMsgService) { }
    
    private _isFail: boolean = false;
    public set isFail(fail: boolean) {
        this._isFail = fail;
    }
    
    private _failMsg: string = '';
    public set failMsg(failMsg: string) {
        this._failMsg = failMsg;
    }
       
    showToasterSuccess( header: string, msg: string, timeout: number = 5000 ): void {
        const _header = header != null && header.trim() != '' ? header : 'Success';
        this.showToaster(_header, msg,timeout,IToasterVariant.Success);
    }
  
    showToasterInfo( header: string, msg: string, timeout: number = 10000 ): void {
        const _header = header != null && header.trim() != '' ? header : 'Information';
        this.showToaster(_header, msg,timeout, IToasterVariant.Info);
    }

    showToasterWarning( header: string, msg: string, timeout: number = 10000 ): void {
        const _header = header != null && header.trim() != '' ? header : 'Warning';
        this.showToaster(_header, msg,timeout,IToasterVariant.Warning);
    }

    showToasterError( header: string, msg: string, timeout: number = 10000 ): void {
        const _header = header != null && header.trim() != '' ? header : 'Error';
        this.showToaster(_header, msg,timeout,IToasterVariant.Error);
    }  

    showHttpError(err: HttpErrorResponse, timeout: number = 10000 ): void {
        this.showToaster('ERROR', 'Something went wrong. Server responded with status code: ' + err.status, timeout, IToasterVariant.Error);
        this.msgService.ontoggleSpinnerSet( false );
    }

    private showToaster( header: string,  msg: string, timeout: number, messageType: IToasterVariant ): void {
        const input: IToasterInput = {
            toasterHeader: header,
            toasterMessage: msg,
            toasterTimeoutMs: timeout,
            toasterVariant: messageType
        };
        this.msgService.onShowToasterSet(input);
    }
}

